"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSetRules = void 0;
/**
 * @internal
 * Validates the set rules
 */
function assertSetRules(rules) {
    if (!rules.gameRules)
        throw new Error("The gameRules are undefined in the setRules");
    if (rules.bestOf <= 0) {
        throw new Error("bestOf should be larger or equal than 1");
    }
}
exports.assertSetRules = assertSetRules;
